import React from "react";
import { Link } from "react-router-dom";
import Slider from "../SliderView/MainSlider";
import HomePageBanner from "./homePageBanner";
import ContentLoader from "../Static/contentLoader";
import Helper from "../Helper/helper";
import ExperienceGate from "../Experience/ExperienceGate";
import { t } from "react-multi-lang";
import ContentCard from "../Content/ContentCard";

/**
 * Browse category pages (/category/:id).
 * Reload only when category id changes so rapid Browse switches do not
 * apply a stale home_first_section payload from a previous category.
 *
 * Rows come from CategoryPageResolver via Content Items (VMS + Scheduler).
 * Continue Watching is not used as a Category Browse fallback.
 */
class Category extends Helper {
    state = {
        maindata: null,
        errorHandle: 0,
        loading: true,
        banner: null,
        loadingHomeSecondSection: true,
        homeSecondData: null,
        experience: null,
        category_id: null,
    };

    resolveInputData(match) {
        return {
            page_type: "CATEGORY",
            category_id: match && match.params ? match.params.id : null,
        };
    }

    loadPage(match) {
        const inputData = this.resolveInputData(match);
        this.setState({
            loading: true,
            experience: null,
            loadingHomeSecondSection: true,
            maindata: null,
            banner: null,
            homeSecondData: null,
            category_id: inputData.category_id,
        });
        this.homeFirstSection(inputData);
    }

    componentDidMount() {
        this.loadPage(this.props.match);
    }

    componentDidUpdate(prevProps) {
        const prevId =
            prevProps.match && prevProps.match.params
                ? prevProps.match.params.id
                : null;
        const nextId =
            this.props.match && this.props.match.params
                ? this.props.match.params.id
                : null;
        if (prevId === nextId) {
            return;
        }
        this.loadPage(this.props.match);
    }

    rowItemKey(item, index) {
        return (
            (item &&
                (item.content_item_id ||
                    item.admin_video_id ||
                    item.channel_id ||
                    item.unique_id)) ||
            index
        );
    }

    renderVideoList = (maindata, index) => {
        const categoryId =
            this.state.category_id ||
            (this.props.match && this.props.match.params
                ? this.props.match.params.id
                : null);
        const items = Array.isArray(maindata.data) ? maindata.data : [];
        return (
            <React.Fragment key={index}>
                <div className="main-slidersec">
                    <Link
                        to={{
                            pathname: "/view-all",
                            state: {
                                url_type: maindata.url_type,
                                url_type_id: maindata.url_type_id,
                                page_type: "CATEGORY",
                                category_id: categoryId,
                                title: maindata.title
                            }
                        }}
                    >
                        <h3 className="">
                            {maindata.title}
                            <i className="fas fa-angle-right ml-2" />
                        </h3>
                    </Link>

                    <Slider>
                        {items.map((movie, i) => (
                            <ContentCard
                                movie={movie}
                                key={this.rowItemKey(movie, i)}
                            />
                        ))}
                    </Slider>
                </div>
            </React.Fragment>
        );
    };

    renderVideoNoData = (maindata, index) => {
        return (
          <React.Fragment key={index}>
          </React.Fragment>
        );
      };

    render() {
        const {
            loading,
            maindata,
            banner,
            loadingHomeSecondSection,
            homeSecondData,
            experience
        } = this.state;

        const firstRows = Array.isArray(maindata) ? maindata : [];
        const secondRows = Array.isArray(homeSecondData) ? homeSecondData : [];

        return (
            <ExperienceGate
                destinationType="category"
                presentation={experience}
            >
            <div>
                {loading ? (
                    <ContentLoader />
                ) : (
                    <HomePageBanner banner={banner} />
                )}
                <div className="main p-40">
                    {loading
                        ? ""
                        : firstRows.map((mainDa, index) =>
                              !mainDa.data || mainDa.data.length === 0
                                  ? this.renderVideoNoData(mainDa, index)
                                  : loading
                                  ? t("loading")
                                  : this.renderVideoList(mainDa, index)
                          )}

                    {loadingHomeSecondSection
                        ? ""
                        : secondRows.map((mainDa, index) =>
                              !mainDa.data || mainDa.data.length === 0
                                  ? ""
                                  : loading
                                  ? t("loading")
                                  : this.renderVideoList(mainDa, index)
                          )}

                    <div className="height-100" />
                </div>
            </div>
            </ExperienceGate>
        );
    }
}

export default Category;
